import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

/**
 * Componente header.
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  /**
   * Contiene la url para ir a play.
   */
  playUrl: string;
  /**
   * Contiene la url para ir a la app.
   */
  appUrl: string;

  /**
   * Constructor.
   */
  constructor() {
    this.appUrl = environment.appUrl;
    this.playUrl = environment.playUrl;
  }
}
